// components/DateFild.js
import React from 'react';
import DatePicker from 'react-date-picker';
import { FaRegCalendarAlt, FaRedo } from "react-icons/fa";

// Format to DD-MM-YYYY
const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;  // Changed from / to -
};

// Parse from multiple string formats
const parseDate = (input) => {
    if (!input) return null;
    if (input instanceof Date && !isNaN(input)) return input;
    if (typeof input !== 'string') return null;

    // Handle DD-MM-YYYY (updated to handle dashes)
    if (input.includes('-')) {
        // Check if it's DD-MM-YYYY format by looking at the first character
        const parts = input.split('-');
        if (parts.length === 3) {
            // If first part is 2 digits or less, assume DD-MM-YYYY
            if (parts[0].length <= 2) {
                const [dd, mm, yyyy] = parts;
                const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
                if (!isNaN(date)) return date;
            }
            // If first part is 4 digits, assume YYYY-MM-DD
            else if (parts[0].length === 4) {
                const [yyyy, mm, dd] = parts;
                const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
                if (!isNaN(date)) return date;
            }
        }
    }

    // Handle DD/MM/YYYY (keep backward compatibility)
    if (input.includes('/')) {
        const [dd, mm, yyyy] = input.split('/');
        const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        if (!isNaN(date)) return date;
    }

    return null;
};

const DateFild = ({ value, onChange }) => {
    const parsedDate = parseDate(value);

    const handleChange = (dateObj) => {
        const formatted = formatDate(dateObj);
        onChange(formatted); // Send DD-MM-YYYY to parent
    };

    return (
        <DatePicker
            onChange={handleChange}
            value={parsedDate}
            format="dd-MM-yyyy"  // Changed from dd/MM/yyyy
            clearIcon={<FaRedo />}
            calendarIcon={<FaRegCalendarAlt />}
            dayPlaceholder="dd"
            monthPlaceholder="mm"
            yearPlaceholder="yyyy"
        />
    );
};

export default DateFild;